module.exports = __webpack_public_path__ + "8c81b87868c8479a8b50a482adad9a5e.png";